import { Component } from '@angular/core'
import {
  StoreService
} from '@se-po/se-household-setup-data-access-store'
import { UserServiceResources as us } from 'se-resource-types'

@Component({
  selector: 'se-po-household-setup-feature-child-contact-info-docs',
  templateUrl: './child-contact-info-docs.component.html',
  styleUrls: ['./child-contact-info-docs.component.scss'],
  standalone: false,
})
export class ChildContactInfoDocsComponent {
  constructor(
    public store: StoreService,
  ) {
    store.childPersona = {
      first_name: 'Chaz',
      last_name: 'Todderson',
      gender: 'female',
      date_of_birth: '1994-06-20',
    } as us.Persona
  }
}
